export const MAINAPIURL = "https://gymapi.dsmapps.com/api";
//export const MAINAPIURL = "http://localhost/Backend/api";
// export const MAINAPIURL = "https://api.acticswellness.com/api";
export const SYSTEMNAME = "Actics Fitness Studio";
export const MAINVERSION = "1.7.11";
export const CUSTOMERNAME = "Actics Fitness Studio";
export const APPBACKGROUND_COLOR = "#ddeef5ff";

// PDF Report Settings
export const COMPANY_NAME = "GYM SYSTEM";
export const COMPANY_ADDRESS_LINE1 = "123 Fitness Street";
export const COMPANY_ADDRESS_LINE2 = "Colombo, Sri Lanka";
export const COMPANY_PHONE = "+94 77 123 4567";
export const COMPANY_LOGO_PATH = "/sitelogo.png";
export const REPORT_FOOTER_TEXT = "Generated by GYM Master System";